import { Inject, Injectable } from '@angular/core';
import { IUnitOfWork } from 'src/app/common/contracts/unit-of-work/unit-of-work';
import { IUnitOfWorkFactory } from 'src/app/common/contracts/unit-of-work/unit-of-work-factory';
import { ErpTaskDB } from 'src/app/common/repository/databases';
import { UnitOfWorkFactory } from 'src/app/common/unit-of-work/unit-of-work-factory';
import { ErpTaskDto } from 'src/app/shared/models/erpTask/erp-task-dto.model';

import { WorkItem } from '../work-item';

@Injectable({ providedIn: 'root' })
export class ErpTaskWorkItem extends WorkItem<ErpTaskDto> {
  unitOfWork: IUnitOfWork;

  constructor(@Inject(UnitOfWorkFactory) unitOfWorkFactory: IUnitOfWorkFactory) {
    super(unitOfWorkFactory);
  }

  get name(): string {
    return 'ErpTaskWorkItem';
  }

  get database(): string {
    return ErpTaskDB;
  }
}
